import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useDeleteLayout() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (ids: number[]) => {
      return await api.layout.delete(ids)
    },
    onSuccess: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.LAYOUTS]})
      enqueueSnackbar('Layout deletado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível deletar o layout no momento')
    },
  })
  return mutation
}
